import React from 'react';

const FreeMockExamCompletedModal = ({ isOpen, onClose, onUpgrade, source = 'Mock Exam' }) => {
  if (!isOpen) return null;

  const handleUpgradeClick = () => {
    onClose(); // Ferme ce modal
    onUpgrade(); // Informe le parent d'ouvrir le pricing modal
  };

  return (
    <>
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px'
        }}
        onClick={(e) => {
          // Ne ferme que si on clique sur le backdrop, pas sur le contenu
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '24px 32px',
          maxWidth: '400px',
          width: '100%',
          textAlign: 'center',
          fontFamily: "'Manrope', sans-serif",
          position: 'relative',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }}>

          {/* Title */}
          <h2 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px',
            lineHeight: '1.3'
          }}>
            You've already completed your free mock exam!
          </h2>

          {/* Description */}
          <p style={{
            fontSize: '14px',
            color: '#6B7280',
            lineHeight: '1.5',
            marginBottom: '24px'
          }}>
            Upgrade to Premium for more full mock exams, analytics and personalized trainings.
          </p>

          {/* Buttons */}
          <div style={{
            display: 'flex',
            flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
            gap: '12px',
            justifyContent: 'center'
          }}>
            <button
              onClick={onClose}
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                border: '1px solid #E5E7EB',
                backgroundColor: 'white',
                color: '#374151',
                fontWeight: '600',
                fontSize: '14px',
                cursor: 'pointer',
                fontFamily: "'Manrope', sans-serif",
                minWidth: '120px'
              }}
            >
              Continue Free
            </button>
            
            <button
              onClick={handleUpgradeClick}
              style={{
                padding: '14px 32px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#9333EA',
                color: 'white',
                fontWeight: '700',
                fontSize: '16px',
                cursor: 'pointer',
                fontFamily: "'Manrope', sans-serif",
                minWidth: '120px'
              }}
            >
              Upgrade Now
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default FreeMockExamCompletedModal;